import React, { Component } from "react";
import { Base } from "zina-dogi-react";
import { OETDashboardReport } from "../components";

class OetDashboardReport extends Component {
    render() {
        const { extraProps } = this.props;
        const base_op = {
            className: "oet_dashboard_report",
            title: "OET Dashboard Report",
            breadcrumbs: [{ name: "Home", rel: "/", icon: "home" }, { name: "OET Dashboard Report" }],
            extraProps,
            loading: false
        };
        return (
            <Base {...base_op}>
                <OETDashboardReport />
            </Base>
        );
    }
}

export default OetDashboardReport;
